import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-calendar',
  templateUrl: './app-calendar.component.html',
  styleUrls: ['./app-calendar.component.scss']
})
export class AppCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
